/**
 * @jsxRuntime classic
 * @jsx jsx
 */

import { jsx } from '@compiled/react';

import { Flex, Text } from '@atlaskit/primitives/compiled';

import { CopyButton } from './copy-button';

interface UnitIdRowProps {
	unitId: string;
}

export const UnitIdRow = ({ unitId }: UnitIdRowProps) => {
	return (
		<Flex alignItems="start" gap="space.075">
			<Text color="color.text.subtle" weight="regular" as="p" size="medium">
				{unitId}
			</Text>
			<CopyButton unitId={unitId} />
		</Flex>
	);
};
